<div class="subscription-page page-shell">
  <mat-toolbar class="header">
    <div class="header-title">
      <span>{{ "subscription.title" | translate }}</span>
      <span class="current-plan-badge" *ngIf="currentPlan">{{
        currentPlan | titlecase
      }}</span>
    </div>
    <div class="header-buttons">
      <mat-form-field
        class="currency-field"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-label>{{ "subscription.currency" | translate }}</mat-label>
        <mat-select
          [(value)]="selectedCurrency"
          (selectionChange)="onCurrencyChange($event.value)"
        >
          <mat-option
            *ngFor="let currency of availableCurrencies"
            [value]="currency"
            >{{ currency }}</mat-option
          >
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="billing-period-field"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-label>{{ "subscription.billingPeriod" | translate }}</mat-label>
        <mat-select
          [value]="isYearly ? 'yearly' : 'monthly'"
          (selectionChange)="onBillingPeriodChange($event.value)"
        >
          <mat-option value="monthly">{{
            "subscription.billingMonthly" | translate
          }}</mat-option>
          <mat-option value="yearly">{{
            "subscription.billingYearly" | translate
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="manageSubscription()">
        <mat-icon>settings</mat-icon>
        {{ "subscription.manageSubscription" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div
    class="subscription-content"
    [class.subscription-content--loading]="isLoading"
    [attr.aria-hidden]="isLoading"
  >
    <section class="form-section">
      <p class="plan-description">{{ "subscription.description" | translate }}</p>
      <p class="plan-subtitle">{{ "subscription.subtitle" | translate }}</p>
    </section>

    <section class="form-section">
      <div class="mobile-view" *ngIf="isMobile">
        <div
          class="mobile-plan-card"
          *ngFor="let planName of ['Basic', 'Premium']"
        >
          <div class="plan-header">
            <h3 class="plan-name">{{ planName | titlecase }}</h3>
            <div class="current-plan-badge" *ngIf="isCurrentPlan(planName)">
              {{ "subscription.currentPlan" | translate }}
            </div>
          </div>
          <div class="plan-price">
            <span class="price-amount">{{ getPlanPrice(planName) }}</span>
            <span class="price-period">{{
              (isYearly
                ? "subscription.periods.year"
                : "subscription.periods.month"
              ) | translate
            }}</span>
          </div>
          <p class="plan-description-mobile">
            {{ getPlanDescription(planName) }}
          </p>

          <div class="features-section">
            <div *ngFor="let row of featureRows; trackBy: trackByRow; let i = index">
              <div
                *ngIf="
                  row.feature === 'subscription.keyFeaturesInDetail' &&
                  shouldShowMobileRow(row, i, planName)
                "
                class="mobile-expandable-header"
                (click)="toggleMobileKeyFeatures(planName)"
              >
                <span>{{ row.feature | translate }}</span>
                <span
                  class="expand-icon"
                  [class.expanded]="mobileKeyFeaturesExpanded[planName]"
                ></span>
              </div>
              <div
                *ngIf="
                  row.feature !== 'subscription.keyFeaturesInDetail' &&
                  shouldShowMobileRow(row, i, planName)
                "
                class="feature-item"
              >
                <span class="feature-name">{{ row.feature | translate }}</span>
                <span
                  class="feature-value"
                  [class.available]="row[planName.toLowerCase()] === 'yes'"
                  [class.unavailable]="row[planName.toLowerCase()] === ''"
                >
                  {{
                    row[planName.toLowerCase()] === "yes"
                      ? "✓"
                      : row.feature === "subscription.features.licenses"
                        ? row[planName.toLowerCase()] === "3"
                          ? ("subscription.licenses.upTo"
                            | translate: { licenses: "3" })
                          : ("subscription.licenses.min"
                            | translate: { licenses: "10" })
                        : getTranslatedValue(row[planName.toLowerCase()] || "")
                  }}
                </span>
              </div>
            </div>
          </div>

          <button
            mat-raised-button
            color="primary"
            class="subscribe-btn"
            [disabled]="isCurrentPlan(planName)"
            (click)="subscribeToPlan(planName)"
          >
            {{
              isCurrentPlan(planName)
                ? ("subscription.yourPlanNow" | translate)
                : ("subscription.subscribe" | translate)
            }}
          </button>
        </div>
      </div>

      <div class="desktop-view" *ngIf="!isMobile">
        <div class="table-container">
          <table class="comparison-table">
            <tbody>
              <tr
                *ngFor="let row of featureRows; trackBy: trackByRow; let i = index"
                [style.display]="shouldShowRow(row, i) ? 'table-row' : 'none'"
              >
                <td
                  *ngIf="row.feature === 'subscription.keyFeaturesInDetail'"
                  class="feature-cell section-header-feature"
                  [attr.colspan]="3"
                >
                  <div class="expandable-header" (click)="toggleKeyFeatures()">
                    <span>{{ row.feature | translate }}</span>
                    <span
                      class="expand-icon"
                      [class.expanded]="isKeyFeaturesExpanded"
                    ></span>
                  </div>
                </td>

                <td
                  *ngIf="row.feature !== 'subscription.keyFeaturesInDetail'"
                  class="feature-cell"
                >
                  <span>{{ row.feature | translate }}</span>
                </td>

                <ng-container
                  *ngIf="row.feature !== 'subscription.keyFeaturesInDetail'"
                >
                  <td
                    class="plan-cell"
                    *ngFor="let planName of ['Basic', 'Premium']"
                    [class.plan-header-cell]="i === 0"
                    [class.current-plan-column]="isCurrentPlan(planName)"
                  >
                    <div *ngIf="i === 0" class="plan-header-content">
                      <div class="plan-header-row">
                        <div class="plan-name">{{ planName | titlecase }}</div>
                        <div
                          class="current-plan-badge"
                          *ngIf="isCurrentPlan(planName)"
                        >
                          {{ "subscription.currentPlan" | translate }}
                        </div>
                      </div>
                      <div class="plan-price">
                        <span class="price-amount">{{
                          getPlanPrice(planName)
                        }}</span>
                        <span class="price-period">{{
                          (isYearly
                            ? "subscription.periods.year"
                            : "subscription.periods.month"
                          ) | translate
                        }}</span>
                      </div>
                      <div class="plan-description">
                        {{ getPlanDescription(planName) }}
                      </div>
                      <button
                        mat-raised-button
                        color="primary"
                        class="subscribe-btn"
                        [disabled]="isCurrentPlan(planName)"
                        (click)="subscribeToPlan(planName)"
                      >
                        {{
                          isCurrentPlan(planName)
                            ? ("subscription.yourPlanNow" | translate)
                            : ("subscription.subscribe" | translate)
                        }}
                      </button>
                    </div>
                    <span
                      *ngIf="i !== 0"
                      class="feature-value"
                      [class.available]="row[planName.toLowerCase()] === 'yes'"
                      [class.unavailable]="row[planName.toLowerCase()] === ''"
                    >
                      {{
                        row[planName.toLowerCase()] === "yes"
                          ? "✓"
                          : row.feature === "subscription.features.licenses"
                            ? row[planName.toLowerCase()] === "3"
                              ? ("subscription.licenses.upTo"
                                | translate: { licenses: "3" })
                              : ("subscription.licenses.min"
                                | translate: { licenses: "10" })
                            : getTranslatedValue(
                                row[planName.toLowerCase()] || ""
                              )
                      }}
                    </span>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="isLoading">
    <app-loading></app-loading>
  </div>
</div>
